import React, { useContext } from 'react'
import { DownloadCSVButton } from '../../../components/common/download-csv-button/DownloadCSVButton'
import { IOverviewFilter } from './ResourcesOverviewTable'
import { DownloadResourcesCsvDocument } from './DownloadResourcesCSV.codegen'
import { AnalyticsContext } from '../AnalyticsContext'
import { prepareCSVResourcesExport } from './csv-resources'

export interface IResourceCsvResponse {
  passRate: number
  viewsCount: number
  topic: {
    id: number
    averageRating: number
    number_rated: number
    currentTitle: string
    lastViewedAt: string
    deleted_at: string
    created_at: string
    currentTopicVersion: {
      id: number
      version: string
      created_at: Date
      pass_mark: number
    }
    workspace: {
      name: string
      id: number
    }
    author: {
      id: number
      email: string
      first_name: string
      last_name: string
      position: string
      area: string
      location: string
      department: string
      custom_1: string
      custom_2: string
      custom_3: string
      account_name: string
    }
  }
}

interface IDownloadResourcesCSVProps {
  resourcesOverviewFilter: IOverviewFilter
  resourcesCount: number
}

export const DownloadResourcesCSV = ({
  resourcesOverviewFilter,
  resourcesCount
}: IDownloadResourcesCSVProps) => {
  const { filterAsQueryVariables } = useContext(AnalyticsContext)
  return (
    <DownloadCSVButton
      count={resourcesCount}
      fileName={'looop-resources'}
      dataPath={'data.analytics.resources.resourcesOverview'}
      queryOptions={(page, limit) => ({
        variables: {
          mainAnalyticsFilter: filterAsQueryVariables,
          resourcesOverviewFilter: {
            ...resourcesOverviewFilter,
            page,
            limit
          }
        },
        query: DownloadResourcesCsvDocument,
        fetchPolicy: 'no-cache'
      })}
      prepareData={prepareCSVResourcesExport}
    />
  )
}
